module.exports = __webpack_public_path__ + "static/media/fruit_jesus_1.2d37aed1.jpeg";